/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KillswitchMutationReceipt = {
  id: string;
  replayed: boolean;
  version: number;
};

/** @internal */
export const KillswitchMutationReceipt$inboundSchema: z.ZodMiniType<
  KillswitchMutationReceipt,
  unknown
> = z.object({
  id: z.string(),
  replayed: z.boolean(),
  version: z.int(),
});

export function killswitchMutationReceiptFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchMutationReceipt, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchMutationReceipt$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchMutationReceipt' from JSON`,
  );
}
